module.exports = __webpack_public_path__ + "img/professional-services-icon.9beba836.svg";